import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #f5f5f5;
  padding: 4rem;
`;

const Title = styled(motion.h1)`
  font-size: 4rem;
  font-weight: 700;
  color: #042E4B;
  margin-bottom: 4rem;
  text-align: center;
`;

const DiagramContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;
  max-width: 1400px;
  width: 100%;
`;

const ChannelSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

const ChannelTitle = styled(motion.h2)`
  font-size: 2.5rem;
  color: #EF443C;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 1rem;
`;

const ChannelCard = styled(motion.div)`
  background: white;
  border-radius: 20px;
  padding: 3rem;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
  border: 3px solid #042E4B;
  display: flex;
  align-items: center;
  gap: 2rem;
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-5px);
  }
`;

const ChannelIcon = styled.div`
  font-size: 4rem;
  width: 90px;
  height: 90px;
  background: linear-gradient(135deg, #EF443C, #C43931);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-shadow: 0 6px 20px rgba(239, 68, 60, 0.3);
`;

const ChannelText = styled.div`
  font-size: 1.6rem;
  color: #042E4B;
  font-weight: 600;
`;

const PartnerGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.5rem;
`;

const PartnerCard = styled(motion.div)`
  background: linear-gradient(135deg, #042E4B, #0A4A6F);
  color: white;
  border-radius: 16px;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  box-shadow: 0 6px 24px rgba(4, 46, 75, 0.3);
`;

const PartnerIcon = styled.div`
  font-size: 3rem;
`;

const PartnerLabel = styled.div`
  font-size: 1.3rem;
  font-weight: 600;
  text-align: center;
`;

const BenefitBadge = styled(motion.div)`
  background: rgba(34, 197, 94, 0.15);
  border: 2px solid #22C55E;
  color: #042E4B;
  padding: 1.5rem 3rem;
  border-radius: 50px;
  font-size: 1.4rem;
  font-weight: 700;
  text-align: center;
  margin-top: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
`;

const Slide11GoToMarket: React.FC = () => {
  const partners = [
    { icon: '👔', label: 'Consultores' },
    { icon: '🧮', label: 'Contadores' },
    { icon: '🎓', label: 'Professores' },
    { icon: '🏛️', label: 'Entidades' },
  ];

  return (
    <Container>
      <Title
        initial={{ y: -30, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.3 }}
      >
        Estratégia Go-to-Market
      </Title>

      <DiagramContainer>
        <ChannelSection>
          <ChannelTitle
            initial={{ x: -30, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.3, delay: 0.1 }}
          >
            <span>📍</span>
            <span>Canal 1</span>
          </ChannelTitle>
          
          <ChannelCard
            initial={{ x: -50, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.4, delay: 0.2 }}
          >
            <ChannelIcon>🌐</ChannelIcon>
            <ChannelText>Venda Direta<br/><span style={{ fontSize: '1.2rem', color: '#607C90' }}>Site / E-commerce</span></ChannelText>
          </ChannelCard>
        </ChannelSection>

        <ChannelSection>
          <ChannelTitle
            initial={{ x: 30, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.3, delay: 0.15 }}
          >
            <span>🤝</span>
            <span>Canal 2</span>
          </ChannelTitle>
          
          <PartnerGrid>
            {partners.map((partner, index) => (
              <PartnerCard
                key={`partner-${partner.label}`}
                initial={{ y: 50, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ duration: 0.3, delay: 0.25 + index * 0.05 }}
              >
                <PartnerIcon>{partner.icon}</PartnerIcon>
                <PartnerLabel>{partner.label}</PartnerLabel>
              </PartnerCard>
            ))}
          </PartnerGrid>
        </ChannelSection>
      </DiagramContainer>

      <BenefitBadge
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.4, delay: 0.6 }}
      >
        <span>🎁</span>
        <span>Acesso gratuito para parceiros estratégicos</span>
      </BenefitBadge>
    </Container>
  );
};

export default Slide11GoToMarket;
